import React from "react";
import { Mail, Instagram, MapPin, MessageCircle } from "lucide-react";
import { createWhatsAppLink } from "../../lib/staticProducts";

export default function Contact() {
    return (
        <section
            id="kontakt"
            data-testid="contact-section"
            className="relative py-24 md:py-32 bg-cream-100 border-t border-cream-300"
        >
            <div className="max-w-6xl mx-auto px-6 md:px-10">
                <div className="text-center max-w-2xl mx-auto reveal">
                    <span className="divider-dot mb-8">
                        <span>Kontakt</span>
                    </span>
                    <h2
                        className="font-serif font-light text-4xl sm:text-5xl text-ink-900 tracking-tight leading-[1.1]"
                        data-testid="contact-heading"
                    >
                        Wir freuen uns
                        <br />
                        <em className="italic text-mauve-500">
                            von dir zu hören.
                        </em>
                    </h2>
                    <p className="mt-6 text-base md:text-lg text-ink-700 leading-relaxed font-light">
                        Egal ob Frage, Kollaboration oder einfach ein lieber
                        Gruß — schreib uns gerne.
                    </p>
                </div>

                <div className="mt-16 grid md:grid-cols-3 gap-10 md:gap-6 max-w-4xl mx-auto">
                    <a
                        href="https://wa.me/4915229516378?text=Hallo,%20ich%20möchte%20dieses%20Produkt%20bestellen."
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="contact-whatsapp"
                        className="reveal group flex flex-col items-center text-center px-6 py-10 bg-cream-50 hover:bg-cream-200 transition-colors"
                    >
                        <MessageCircle
                            size={22}
                            className="text-mauve-500 mb-5"
                            strokeWidth={1.2}
                        />
                        <p className="text-[11px] tracking-[0.28em] uppercase text-ink-500 font-light mb-3">
                            WhatsApp
                        </p>
                        <p className="font-serif text-lg text-ink-900 group-hover:text-mauve-500 transition-colors">
                            Jetzt schreiben
                        </p>
                    </a>

                    <a
                        href="https://www.instagram.com/dar_almidad?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="contact-instagram"
                        className="reveal group flex flex-col items-center text-center px-6 py-10 bg-cream-50 hover:bg-cream-200 transition-colors"
                    >
                        <Instagram
                            size={22}
                            className="text-mauve-500 mb-5"
                            strokeWidth={1.2}
                        />
                        <p className="text-[11px] tracking-[0.28em] uppercase text-ink-500 font-light mb-3">
                            Instagram
                        </p>
                        <p className="font-serif text-lg text-ink-900 group-hover:text-mauve-500 transition-colors">
                            @daralmidad
                        </p>
                    </a>

                    <div
                        data-testid="contact-location"
                        className="reveal group flex flex-col items-center text-center px-6 py-10 bg-cream-50"
                    >
                        <MapPin
                            size={22}
                            className="text-mauve-500 mb-5"
                            strokeWidth={1.2}
                        />
                        <p className="text-[11px] tracking-[0.28em] uppercase text-ink-500 font-light mb-3">
                            Standort
                        </p>
                        <p className="font-serif text-lg text-ink-900">
                            Deutschland
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
